
import { Inject, Injectable } from '@nestjs/common';
import { DataSource } from 'typeorm';
import { InjectDataSource } from '@nestjs/typeorm';
import { OrdersRepository } from './dto/category-repo';
import { CategoryActivateReq, CategoryIdRequest, CategoryReq, CategoryResponseModel, CommonResponseModel } from '@project-management-system/shared-models';
import { CategoryEntity } from './dto/category-entity';
import { CategoryDto } from './dto/category-dto';
import { M3TrimsCategoryMappingRepo } from '../../m3-trims/m3-trims-category-mapping.repo';
import { CategoryMappingEntity } from '../../m3-trims/m3-trims-category-mapping.entity';
import { GenericTransactionManager } from '../../../typeorm-transactions/generic-transaction-manager';
@Injectable()

export class CategoryService{
    @InjectDataSource()
    private datasource: DataSource
    constructor(
        private categoryRepo:OrdersRepository,
        private m3TrimsCategoryMappingRepo:M3TrimsCategoryMappingRepo,
        private readonly dataSource: DataSource

    ){}

    // async createCategory(req:CategoryDto,isUpdate: boolean):Promise<CommonResponseModel>{
    //     try{
    //         console.log(req,"req,ser")
    //         const entity = new CategoryEntity()
    //             entity.category=req.category
    //             entity.categoryCode=req.categoryCode
    //             if(isUpdate){
    //                 entity.categoryId=req.categoryId
    //                 entity.updatedUser=req.updatedUser
    //             }else{
    //                 entity.createdUser=req.createdUser
    //             }
    //             const save = await this.categoryRepo.save(entity)
    //             if(save.categoryId > 0){
    //                 let reqData = new CategoryMappingEntity();
    //                 reqData.trimCategory = req.trimCategoryId;
    //                 reqData.categoryId = save.categoryId;
    //                 console.log(reqData)
    //                 const mapCategory = await this.m3TrimsCategoryMappingRepo.save(reqData);
    //                 console.log(mapCategory);
    //                 if(mapCategory.categoryMappingId > 0){
    //                     return new CommonResponseModel(true,1,isUpdate ? 'Category Updated Successfully' : 'Category Created Successfully')
    //                 }
    //                 else{
    //                     return new CommonResponseModel(false, 0, "Something went wrong. ")
    //                 }
    //             }else{
    //                 return new CommonResponseModel(false,0,'Something Went wrong')
    //             }

    //     }
    //     catch(err){
    //         throw err
    //     }
    // }

    async createCategory(dto: CategoryDto, isUpdate: boolean): Promise<CommonResponseModel> {
        try {
          const manager = this.dataSource;
          let existingCategory;
          let existingCategoryCode;
      
          if (!isUpdate) {
            const query = `
          SELECT trim_category,c.category FROM category_mapping cm
          LEFT JOIN category c ON c.category_id = cm.category_id
          WHERE c.category='${dto.category}' AND cm.trim_category = ${dto.trimCategoryId} `
          const existingCategory = await manager.query(query)
            // existingCategoryCode = await this.categoryRepo.findOne({ where: { categoryCode: dto.categoryCode }});
      
            if (existingCategory.length > 0 ) {
              throw new Error('Category Already Exists');
            } else if (existingCategoryCode) {
              throw new Error('Category Code already exists');
            }
          } else {
            const categoryToUpdate = await this.categoryRepo.findOne({ where: { categoryId: dto.categoryId } });
            if (!categoryToUpdate) {
              throw new Error('Category to update not found');
            }
      
            const existingCategoryName = await this.categoryRepo.findOne({ where: { category: dto.category } });
            const existingCode =await this.categoryRepo.findOne({where:({categoryCode:dto.categoryCode})})
            if (existingCategoryName && existingCategoryName.categoryId !== dto.categoryId) {
              throw new Error('Category Already Exists');
            }
            else if(existingCode && existingCode.categoryId !== dto.categoryId){
              throw new Error("Category Code Already Exists")
            }
          }
      
          const entityData = new CategoryEntity();
          entityData.category = dto.category;
          entityData.categoryCode = dto.categoryCode;
          entityData.isActive = dto.isActive === undefined || dto.isActive === null ? true : dto.isActive;
      
          if (isUpdate) {
            entityData.categoryId = dto.categoryId;
            entityData.updatedUser = dto.updatedUser;
          } else {
            entityData.createdUser = dto.createdUser;
          }
          const data = await this.categoryRepo.save(entityData);
          if (data && !isUpdate) {
            let reqData = new CategoryMappingEntity();
            reqData.trimCategory = dto.trimCategoryId;
            reqData.categoryId = data.categoryId;
            // console.log(reqData)
            const mapCategory = await this.m3TrimsCategoryMappingRepo.save(reqData);
            // console.log(mapCategory);
            if(mapCategory.categoryMappingId > 0){
                return new CommonResponseModel(true, 1, isUpdate ? 'Category Updated Successfully' : 'Category Created Successfully', data);
            }
            else{
                return new CommonResponseModel(false, 0, "Something went wrong. ")
            }
        } 
        else if (data && isUpdate) {
          return new CommonResponseModel(true, 1, isUpdate ? 'Category Updated Successfully' : 'Category Created Successfully', data);
        }
        else {
            return new CommonResponseModel(false, 0, 'Something Went Wrong');
        }
        } catch (err) {
          throw err;
        }
      }

    async getAllCategory():Promise<CommonResponseModel>{
        const style = await this.categoryRepo.find({
            order:{category:'ASC'}
        })
        // console.log(style);
        if(style.length >0){
            return new CommonResponseModel(true,1,'Active Categories Retrived Sucessfully',style)
        }else{
            return new CommonResponseModel(false,0,'No  Categories Found ',[])

        }

    }
    async getAllActiveCategory():Promise<CommonResponseModel>{
        const style = await this.categoryRepo.find({
            where:{isActive:true},
            order:{category:'ASC'}
        })
        // console.log(style);
        if(style.length >0){
            return new CommonResponseModel(true,1,'Active Categories Retrived Sucessfully',style)
        }else{
            return new CommonResponseModel(false,0,'No  Categories Found ',[])

        }

    }
    async activeteOrDeactivateCategory(req: CategoryActivateReq): Promise<CategoryResponseModel> {
        try {
            const ColumnExists = await this.categoryRepo.findOne({where:{categoryId:req.categoryId}});
            if (ColumnExists) {
                if (req.versionFlag !== ColumnExists.versionFlag) {
                    return new CategoryResponseModel(false,10113, 'Someone updated the current Category information.Refresh and try again');
                } else {
    
                    const ColumnStatus = await this.categoryRepo.update(
                        { categoryId: req.categoryId },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
    
                    if (ColumnExists.isActive) {
                        if (ColumnStatus.affected) {
                            const busAreaResponse: CategoryResponseModel = new CategoryResponseModel(true, 10115, 'Category is Deactivated successfully');
                            return busAreaResponse;
                        } else {
                            return new CategoryResponseModel(false,10111, 'Category is already Deactivated');
                        }
                    } else {
                        if (ColumnStatus.affected) {
                            const busAreaResponse: CategoryResponseModel = new CategoryResponseModel(true, 10114, 'Category is Activated successfully');
                            return busAreaResponse;
                        } else {
                            return new CategoryResponseModel(false,10112, 'Category is already Activated');
                        }
                    }
                    // }
                    }
            } else {
                return new CategoryResponseModel(false,99998, 'No Records Found');
            }
            } catch (err) {
                return err;
            }
        }

        async getAllCategoriesForCategory(req:CategoryIdRequest): Promise<CommonResponseModel> {
            try {
              // console.log("&&&&&&&&&&&&&&&&&&&&&&&&&")
                const data = await this.m3TrimsCategoryMappingRepo.getAllCategoriesByCategory(req.categoryId)
                if(data.status){
                    return new CommonResponseModel(true, 1, 'Hole data retrieved successfully',data.data)
                }else{
                    return new CommonResponseModel(false, 0, 'No data found',[])
                }
            } catch (err) {
              return err;
            }
          }
}
